<template>
  <v-app>
    <v-content>
      <router-view v-if="initialized"></router-view>
      <loading-layout v-else></loading-layout>
    </v-content>
  </v-app>
</template>

<script>
import LoadingLayout from './layouts/LoadingLayout.vue';

import AuthService from '../auth/service';

import { NOT_AUTHORIZED } from '../helpers/events';

export default {
  data() {
    return {
      initialized: false,
    };
  },
  created() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    this.$eventHub.$once(NOT_AUTHORIZED, this.handleNotAuthorized.bind(this));
  },
  beforeMount() {
    this.initialize()
      .then(() => {
        this.initialized = true;
      })
      .catch((error) => {
        this.$toast.error(error.message);
      });
  },
  methods: {
    async initialize() {
      await this.refreshAuthToken();
    },
    refreshAuthToken() {
      return AuthService.refreshToken()
        .catch((error) => {
          this.handleNotAuthorized();

          throw error;
        });
    },
    handleNotAuthorized() {
      AuthService.deauthorize()
        .then(() => this.$router.push({ name: 'auth' }));
    },
    handleVisibilityChange() {
      if (document.hidden || !this.initialized) {
        return;
      }

      this.refreshAuthToken()
        .catch((error) => {
          this.$toast.error(error.message);
        });
    },
  },
  components: {
    LoadingLayout,
  },
};
</script>
